import React from 'react';
import { motion } from 'framer-motion';
import { FiTrendingUp, FiClock, FiDollarSign, FiZap } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const reasons = [
  {
    icon: FiTrendingUp,
    title: "Higher Engagement",
    desc: "Video content generates 1200% more shares than text and images combined."
  },
  {
    icon: FiClock,
    title: "Rapid Turnaround",
    desc: "Launch your campaigns in 24-72 hours instead of waiting weeks for editors."
  },
  {
    icon: FiDollarSign,
    title: "80% Cost Reduction",
    desc: "Get cinema-quality production at a fraction of traditional agency costs."
  },
  {
    icon: FiZap,
    title: "Instant Scaling",
    desc: "Easily create hundreds of variations for A/B testing and localized marketing."
  }
];

const VideoWhy = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">The Advantage</h2>
          <p className="text-4xl md:text-5xl font-extrabold text-slate-900">Why Choose AI Video Creation?</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-8 bg-slate-50 rounded-[2rem] border border-slate-100 hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-emerald-600 mb-6 shadow-sm">
                <SafeIcon icon={item.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
              <p className="text-slate-500 font-medium leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoWhy;
